import React, { useMemo } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import { IAssetAllocation, IProfileAssetAllocation } from "store/types/user/social";

import { IFormikValues } from "../EditWindow";
import { AssetComponent } from "./AssetComponent";

interface IComponentProps {
  availableAllocations: IAssetAllocation[];
}

export const AssetAllocation: React.FC<IComponentProps> = ({ availableAllocations }) => {
  const { values } = useFormikContext<IFormikValues>();

  const validAssetAllocation = useMemo(
    () =>
      values.asset_allocations.filter((item: IProfileAssetAllocation) => item.percentage !== 0 && item.title !== ""),
    [values.asset_allocations]
  );
  const assetAllocationsSum = useMemo(
    () => validAssetAllocation.reduce((acc: number, item: IProfileAssetAllocation) => acc + item.percentage, 0),
    [validAssetAllocation]
  );

  return (
    <div style={{ minWidth: "486px", width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "40px 32px" }}>
        <FieldArray
          name="asset_allocations"
          render={(arrayHelpers) => (
            <>
              {values.asset_allocations.map((item: IProfileAssetAllocation, index: number) => {
                return (
                  <AssetComponent
                    key={index}
                    item={item}
                    arrayHelpers={arrayHelpers}
                    index={index}
                    availableAllocations={availableAllocations}
                  />
                );
              })}
            </>
          )}
        />
        <FieldArray
          name="asset_allocations"
          render={(arrayHelpers) => (
            <>
              <Button
                disabled={assetAllocationsSum >= 100}
                onClick={() => arrayHelpers.push({ percentage: 0, title: "", direct: 0 })}
                sx={{ marginBottom: "20px" }}
                variant="outlined"
              >
                Add Asset Type
              </Button>
              <Box sx={{ width: "100%", height: "1px", backgroundColor: "#dae0e2", marginBottom: "10px" }}></Box>
              <Stack direction={"row"} justifyContent={"space-between"} sx={{ padding: "0 110px 0 10px" }}>
                <Typography sx={{ color: "#0a3142", fontSize: "16px" }}>
                  {validAssetAllocation.length} Asset Type
                </Typography>
                <Typography sx={{ color: assetAllocationsSum === 100 ? "#048365" : "#c03636", fontWeight: "bold" }}>
                  {assetAllocationsSum}%
                </Typography>
              </Stack>
            </>
          )}
        />
      </Box>
    </div>
  );
};
